import React, { Component } from 'react';
import {Field} from "redux-form";

// components
import Number from '../StepContent/Number';
import Inner from '../StepContent/Inner';


const required = value => value ? undefined : 'Required';
const adaptFileEventToValue = delegate => e => delegate(e.target.files[0]);

class Step4 extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedFileName: 'No file chosen'
        };
    }

    renderCheckboxField({input, title, boldTitle, url, type, meta: {touched, error}}) {
        return <label className="radio-check">
            <input {...input} type={type} />
            <span></span>{title} <a href={url} target="_blank">{boldTitle}</a>
        </label>;
    }

    renderUploadBtn({
        input: {
            value: omitValue,
            onChange,
            onBlur,
            ...inputProps,
        },
        context,
        meta: omitMeta,
        ...props
        }) {
        return <div className="input-col">
                    <span>Upload cv
                        <input
                            onChange={(e) => {
                                adaptFileEventToValue(onChange);
                                context.setState({
                                    selectedFileName: e.target.files[0] ? e.target.files[0].name : 'No file chosen'
                                });
                            }}
                            onBlur={(e) => {
                                adaptFileEventToValue(onBlur);
                                context.setState({
                                    selectedFileName: e.target.files[0] ? e.target.files[0].name : 'No file chosen'
                                });
                            }}
                            {...inputProps}
                            {...props}
                            type="file" />
                    </span>
                </div>;
    }

    render() {
        let classNames = (this.props.classDone) ? 'stepD ' : 'stepD disableAll';
        if (this.props.className) {
            classNames += ' stepSucc';
        }
        /*console.log(this.props);*/
        return (
            <div className={classNames}>
                <Number number='04' />
                <Inner>
                    <h3>Final form&nbsp;
                        <span>submission</span></h3>
                    <div className="extraGap">
                        <Field name="cvfile"
                               context={this}
                               component={this.renderUploadBtn}
                               type="file"
                        />
                        <span className="selected-file-name">{this.state.selectedFileName}</span>
                        <div className="checkout-terms">
                            <Field name="accept_terms"
                                   type="checkbox"
                                   title="Accept WeWhoDo's"
                                   boldTitle="terms & conditions"
                                   url="https://content.wewhodo.com/terms"
                                   component={this.renderCheckboxField}
                                   validate={[required]}
                            />
                            <Field name="accept_consultant"
                                   type="checkbox"
                                   title="Accept WeWhoDo's"
                                   boldTitle="consultant agreement"
                                    url="https://content.wewhodo.com/consultant-agreement"
                                   component={this.renderCheckboxField}
                                   validate={[required]}
                            />
                        </div>
                    </div>
                    <div className="forNext">
                        <button
                            disabled={this.props.invalidSteps.indexOf("Step4") !== -1}
                            type={'button'}
                            onClick={() => this.props.submit()}
                            name="button" className="btn btn-danger text-uppercase">
                            Submit form
                        </button>
                    </div>
                </Inner>
            </div>
        );
    }
}

export default Step4;



// WEBPACK FOOTER //
// ./src/components/Membership/Step4/index.js